export type MaxPhotoDimension = 256 | 512 | 1024 | 2048;
export const getScanPhotoImageUrl = (scanPhotoId: string, options?: { maxDimension?: MaxPhotoDimension }) =>
  `/api/scan-photo-data/${scanPhotoId}${options?.maxDimension ? `?maxDimension=${options.maxDimension}` : ''}`;
